import { Component, Inject, OnInit } from '@angular/core';
import { BciWkModalService, BCI_WK_MODAL_DATA } from '@bci/webkitbci';

@Component({
  selector: 'app-modal-timeout',
  templateUrl: './modal-timeout.component.html',
  styleUrls: ['./modal-timeout.component.scss'],
  standalone: false
})
export class ModalTimeoutComponent implements OnInit {
  title = 'El tiempo se agotó';
  constructor(
    private modal: BciWkModalService,
    @Inject(BCI_WK_MODAL_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '600px',
        overflowY: 'hidden',
      },
    });
  }

  close() {
    this.data.resendCode();
    this.modal.close();
  }
}
